/**
 * @fileoverview gRPC-Web generated client stub for org.codetricks.construction.code.assistant.io.icc.api.legacy
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.21.12
// source: icc.info.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as icc_info_pb from './icc.info_pb'; // proto import: "icc.info.proto"


export class IccBookInfoServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetIccBookInfo = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfoService/GetIccBookInfo',
    grpcWeb.MethodType.UNARY,
    icc_info_pb.GetIccBookInfoRequest,
    icc_info_pb.GetIccBookInfoResponse,
    (request: icc_info_pb.GetIccBookInfoRequest) => {
      return request.serializeBinary();
    },
    icc_info_pb.GetIccBookInfoResponse.deserializeBinary
  );

  getIccBookInfo(
    request: icc_info_pb.GetIccBookInfoRequest,
    metadata?: grpcWeb.Metadata | null): Promise<icc_info_pb.GetIccBookInfoResponse>;

  getIccBookInfo(
    request: icc_info_pb.GetIccBookInfoRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: icc_info_pb.GetIccBookInfoResponse) => void): grpcWeb.ClientReadableStream<icc_info_pb.GetIccBookInfoResponse>;

  getIccBookInfo(
    request: icc_info_pb.GetIccBookInfoRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: icc_info_pb.GetIccBookInfoResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfoService/GetIccBookInfo',
        request,
        metadata || {},
        this.methodDescriptorGetIccBookInfo,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfoService/GetIccBookInfo',
    request,
    metadata || {},
    this.methodDescriptorGetIccBookInfo);
  }

  methodDescriptorGetMultipleIccBookInfo = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfoService/GetMultipleIccBookInfo',
    grpcWeb.MethodType.UNARY,
    icc_info_pb.GetMultipleIccBookInfoRequest,
    icc_info_pb.GetMultipleIccBookInfoResponse,
    (request: icc_info_pb.GetMultipleIccBookInfoRequest) => {
      return request.serializeBinary();
    },
    icc_info_pb.GetMultipleIccBookInfoResponse.deserializeBinary
  );

  getMultipleIccBookInfo(
    request: icc_info_pb.GetMultipleIccBookInfoRequest,
    metadata?: grpcWeb.Metadata | null): Promise<icc_info_pb.GetMultipleIccBookInfoResponse>;

  getMultipleIccBookInfo(
    request: icc_info_pb.GetMultipleIccBookInfoRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: icc_info_pb.GetMultipleIccBookInfoResponse) => void): grpcWeb.ClientReadableStream<icc_info_pb.GetMultipleIccBookInfoResponse>;

  getMultipleIccBookInfo(
    request: icc_info_pb.GetMultipleIccBookInfoRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: icc_info_pb.GetMultipleIccBookInfoResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfoService/GetMultipleIccBookInfo',
        request,
        metadata || {},
        this.methodDescriptorGetMultipleIccBookInfo,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfoService/GetMultipleIccBookInfo',
    request,
    metadata || {},
    this.methodDescriptorGetMultipleIccBookInfo);
  }

  methodDescriptorGetAvailableBookInfo = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfoService/GetAvailableBookInfo',
    grpcWeb.MethodType.UNARY,
    icc_info_pb.GetAvailableBookInfoRequest,
    icc_info_pb.GetAvailableBookInfoResponse,
    (request: icc_info_pb.GetAvailableBookInfoRequest) => {
      return request.serializeBinary();
    },
    icc_info_pb.GetAvailableBookInfoResponse.deserializeBinary
  );

  getAvailableBookInfo(
    request: icc_info_pb.GetAvailableBookInfoRequest,
    metadata?: grpcWeb.Metadata | null): Promise<icc_info_pb.GetAvailableBookInfoResponse>;

  getAvailableBookInfo(
    request: icc_info_pb.GetAvailableBookInfoRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: icc_info_pb.GetAvailableBookInfoResponse) => void): grpcWeb.ClientReadableStream<icc_info_pb.GetAvailableBookInfoResponse>;

  getAvailableBookInfo(
    request: icc_info_pb.GetAvailableBookInfoRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: icc_info_pb.GetAvailableBookInfoResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfoService/GetAvailableBookInfo',
        request,
        metadata || {},
        this.methodDescriptorGetAvailableBookInfo,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.io.icc.api.legacy.IccBookInfoService/GetAvailableBookInfo',
    request,
    metadata || {},
    this.methodDescriptorGetAvailableBookInfo);
  }

}

